// extracted by mini-css-extract-plugin
export var image = "List-module--image--9ceac";
export var listItem = "List-module--listItem--f0180";
export var listModule = "List-module--listModule--439a1";
export var listWrapper = "List-module--listWrapper--16c57";